<div class="form-content container flex flex-col">
  <div class="header flex flex-row items-center justify-between">
    <div class="title flex flex-row items-center">
      <ion-icon src="../../../assets/icon/phone.svg"></ion-icon>
      <h1>Datos de contacto</h1>
    </div>

    <ion-button fill="clear" (click)="dismiss()">
      <ion-icon src="../../../assets/icon/cross.svg"></ion-icon>
    </ion-button>
  </div>

  <hr />

  <form #ngForm [formGroup]="form" (ngSubmit)="onSubmit()" id="contact-data-form" class="inputs-list flex flex-col">
    <div class="flex flex-col">
      <div class="flex flex-col gap-2.5">
        <label for="recipient">Nombre completo <span>*</span></label>
        <input
          type="text"
          formControlName="recipient"
          id="recipient"
          placeholder="Cyndi Nero"
          [ngClass]="{ error: fieldIsInvalid('recipient') }"
        />
      </div>
      <div class="error-container">
        <ng-container *ngFor="let validation of validationMessages.name">
          <div
            class="error-message"
            *ngIf="
              form.get('recipient').hasError(validation.type) &&
              (form.get('recipient').dirty || form.get('recipient').touched || ngForm.submitted)
            "
          >
            <ion-icon name="information-circle-outline"></ion-icon>
            <span translate>{{ validation.message }}</span>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="flex flex-col">
      <div class="flex flex-col gap-2.5">
        <label for="phone">Teléfono <span>*</span></label>
        <input
          type="text"
          formControlName="phone"
          placeholder="Añade tu teléfono"
          [ngClass]="{ error: fieldIsInvalid('phone') }"
        />
      </div>
      <div class="error-container">
        <ng-container *ngFor="let validation of validationMessages.phone">
          <div
            class="error-message"
            *ngIf="
              form.get('phone').hasError(validation.type) &&
              (form.get('phone').dirty || form.get('phone').touched || ngForm.submitted)
            "
          >
            <ion-icon name="information-circle-outline"></ion-icon>
            <span translate>{{ validation.message }}</span>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="flex flex-col">
      <div class="gap-five flex flex-col">
        <div class="flex flex-col gap-2.5">
          <label for="phone">Email <span>*</span></label>
          <input
            type="text"
            formControlName="email"
            placeholder="bailongo@gmail.com"
            [ngClass]="{ error: fieldIsInvalid('email') }"
          />
        </div>
        <span class="message">Enviaremos la confirmación de tu pedido a este email.</span>
      </div>
      <div class="error-container">
        <div
          class="error-message"
          *ngIf="
            form.get('email').hasError('required') &&
            (form.get('email').dirty || form.get('email').touched || ngForm.submitted)
          "
        >
          <ion-icon name="information-circle-outline"></ion-icon>
          <span translate>Campo obligatorio</span>
        </div>

        <div
          class="error-message"
          *ngIf="
            !form.get('email').hasError('required') &&
            (form.get('email').hasError('email') || form.get('email').hasError('pattern')) &&
            (form.get('email').dirty || form.get('email').touched || ngForm.submitted)
          "
        >
          <ion-icon name="information-circle-outline"></ion-icon>
          <span translate>Correo inválido</span>
        </div>
      </div>
    </div>

    <div class="flex flex-row items-start gap-2.5">
      <ion-checkbox formControlName="replaceContactData" id="replace-contact-data" labelPlacement="end">
        <label for="replace-contact-data" class="message replace">
          Sustituir mis datos de contacto anteriores por estos nuevos. <br />
          <span>Puedes volver a cambiarlo desde "Mi cuenta > Mi perfil"</span>
        </label>
      </ion-checkbox>
    </div>
  </form>

  <hr />

  <div class="bottom-buttons flex flex-row items-center justify-end gap-2.5">
    <ion-button (click)="dismiss()"> Cancelar </ion-button>
    <ion-button (click)="onSubmit()" [disabled]="!form.valid"> Guardar </ion-button>
  </div>
</div>
